import * as React from "react";
import { cn } from "@/lib/cn";

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
}

/**
 * Label — luôn đặt trên input (Volume 02 §13.1).
 * `required` thêm dấu * kèm nhãn trợ năng "Trường bắt buộc".
 */
export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, required, children, ...props }, ref) => (
    <label
      ref={ref}
      className={cn("block text-label text-foreground", className)}
      {...props}
    >
      {children}
      {required && (
        <span className="text-danger" aria-hidden="true">
          {" "}
          *
        </span>
      )}
      {required && <span className="sr-only"> (Trường bắt buộc)</span>}
    </label>
  )
);
Label.displayName = "Label";
